import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";

export default function WishlistPage() {
    const { user } = useAuth();
    const { ids } = useWishlist();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            if (user) {
                const { data } = await api.get("/wishlist");
                setProducts(data.products);
            } else if (ids.length) {
                const { data } = await api.get("/products");
                setProducts(data.products.filter((p) => ids.includes(p.id)));
            } else {
                setProducts([]);
            }
        } finally {
            setLoading(false);
        }
    }, [user, JSON.stringify(ids)]);

    useEffect(() => { load(); }, [load]);

    return (
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-10 md:py-14">
            <p className="eyebrow mb-3">Saved</p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-10">My Wishlist</h1>
            {loading ? (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">{Array.from({ length: 4 }).map((_, i) => <div key={i} className="skeleton aspect-[4/5]" />)}</div>
            ) : products.length === 0 ? (
                <div className="py-20 text-center">
                    <Heart className="h-12 w-12 mx-auto text-gold" strokeWidth={1} />
                    <p className="font-serif text-2xl mt-6">Your wishlist is empty</p>
                    <Link to="/shop" className="inline-block mt-6 bg-gold text-white px-8 py-3.5 text-sm uppercase tracking-[0.15em] hover:bg-gold-hover transition-colors">Explore Products</Link>
                </div>
            ) : (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
            )}
        </div>
    );
}
